export interface BasedModel {
  styleModifier?: string[];
  globalModifiers?: string[];
}

export const getModifiers = (model: BasedModel, baseClass: string) => {
  const classes = [baseClass];

  model.styleModifier?.forEach((m) => classes.push(baseClass + '--' + m));
  model?.globalModifiers?.forEach((m) => classes.push(m));

  return classes.join(' ');
};
